import React from "react";
import {
  getActionType,
  getActionIconClass,
} from "util/reviewActionType";
import styles from "./reviewActionTag.module.scss";

/**
 * Colored moderator action chip/button (safe = green, danger = red, neutral = grey).
 */
export default function ReviewActionTag({
  label,
  onClick,
  active = false,
  isDark = false,
  as = "span",
  className = "",
}) {
  const type = getActionType(label);
  const iconClass = getActionIconClass(type, label);
  const Tag = as;
  const classNames = [
    styles.btnAction,
    styles[type],
    isDark ? styles.darkMode : "",
    active ? styles.active : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag
      type={as === "button" ? "button" : undefined}
      className={classNames}
      data-review-action-tag="true"
      data-action-type={type}
      aria-pressed={as === "button" ? active : undefined}
      onClick={onClick}
    >
      <i className={iconClass} aria-hidden="true" />
      {label}
    </Tag>
  );
}
